import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { usePwaInstall } from '../../hooks/usePwaInstall';
import { applyPwaManifest } from '../../utils/pwa';

/**
 * @param {'admin'|'client'|'both'} mode
 * @param {'card'|'compact'} layout
 */
const PwaInstallPanel = ({ mode = 'client', layout = 'card', className = '' }) => {
  const navigate = useNavigate();
  const { canInstall, isStandalone, promptInstall } = usePwaInstall();

  useEffect(() => {
    if (mode === 'admin') applyPwaManifest('admin');
    else if (mode === 'client') applyPwaManifest('client');
  }, [mode]);

  const handleAdminInstall = async () => {
    applyPwaManifest('admin');
    const result = await promptInstall();
    if (!result.ok && result.reason === 'unavailable') {
      window.alert(
        'Browser-ka: menu → "Install app" / "Add to Home screen". Hubi inaad ku jirto bogga Admin (login).'
      );
    }
  };

  const handleClientInstall = async () => {
    applyPwaManifest('client');
    if (mode === 'both') {
      navigate('/?install=1');
      return;
    }
    const result = await promptInstall();
    if (!result.ok && result.reason === 'unavailable') {
      window.alert(
        'Browser-ka: menu ama 3 : → "Add to Home screen". then install gareyso appka macmiil.'
      );
    }
  };

  if (isStandalone && mode !== 'both') {
    return (
      <div className={`rounded-xl bg-green-50 border border-green-200 p-4 text-sm text-green-800 ${className}`}>
        App-kan waa horey ayaad u install gareysay telefoonkaaga.
      </div>
    );
  }

  const compact = layout === 'compact';

  if (mode === 'both') {
    return (
      <div className={`space-y-4 ${className}`}>
        <div className="rounded-xl border border-red-100 bg-red-50/80 p-4">
          <p className="font-semibold text-gray-900 mb-1">Admin App</p>
          <p className="text-sm text-gray-600 mb-3">
            Dashboard, quotations, invoices, kharash — shaqaalaha maamulka.
          </p>
          <Button type="button" size={compact ? 'sm' : 'md'} onClick={handleAdminInstall}>
            {canInstall ? 'Ku rakib Admin' : 'Ku rakib Admin (Add to Home screen)'}
          </Button>
        </div>
        <div className="rounded-xl border border-blue-100 bg-blue-50/80 p-4">
          <p className="font-semibold text-gray-900 mb-1">Website Macmiilka</p>
          <p className="text-sm text-gray-600 mb-3">
            Bogga hore ee quotation — macmiilku wuu soo dejisan karaa.
          </p>
          <Button type="button" variant="outline" size={compact ? 'sm' : 'md'} onClick={handleClientInstall}>
            Fur website-ka & ku rakib
          </Button>
        </div>
        <p className="text-xs text-gray-500">
          Labada app waa kala duwan (Admin iyo Macmiil). Ku rakib mid kasta markaad joogto boggiisa.
        </p>
      </div>
    );
  }

  const isAdmin = mode === 'admin';
  const title = isAdmin ? 'Ku rakib Admin App' : 'install gareyso App-ka Macmiill';
  const hint = isAdmin
    ? 'Gal /login kadib riix Install ama "Add to Home screen".'
    : 'Riix Install si website-ku u noqdo app sida native.';

  return (
    <div className={`text-center ${compact ? 'py-2' : 'py-4'} ${className}`}>
      {!compact && <img src="/logo.png" alt="" className="w-16 h-16 mx-auto mb-3" />}
      <p className={`font-semibold text-gray-900 ${compact ? 'text-sm' : ''}`}>{title}</p>
      <p className={`text-gray-600 mt-1 ${compact ? 'text-xs' : 'text-sm'}`}>{hint}</p>
      <div className="mt-3 flex flex-col sm:flex-row gap-2 justify-center">
        <Button type="button" size={compact ? 'sm' : 'md'} onClick={isAdmin ? handleAdminInstall : handleClientInstall}>
          {canInstall ? 'Install hadda' : 'Sida loo rakibo'}
        </Button>
        {isAdmin && (
          <Button type="button" variant="outline" size={compact ? 'sm' : 'md'} onClick={() => navigate('/?install=1')}>
            Website macmiilka
          </Button>
        )}
      </div>
    </div>
  );
};

export default PwaInstallPanel;
